import OrderInfo, { type OrderInfoProps } from './OrderInfo';

export type { OrderInfoProps };
export default OrderInfo;
